// extracted by mini-css-extract-plugin
export default {"container":"screensaver_container__a1gWr","animation":"screensaver_animation__rLAcf","floatAnimation":"screensaver_floatAnimation__chSW6"};